import { useEffect, useState } from 'react';
import { getActivePlans, getAllPlans } from '../../../services/PlansService';

/**
 * props:
 * - id
 * - onChange
 * - onPlanChange
 * - required
 */
function SelectPlan(props) {
    const [plans, setPlans] = useState(['LOADING']);

    useEffect(() => {
        let promise;
        if (props.id > 0) {
            promise = getAllPlans();
        } else {
            promise = getActivePlans();
        }

        promise
            .then(planObjects => {
                setPlans(planObjects);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setPlans(['ERROR']);
            });
    }, [props.id]);

    useEffect(() => {
        if (!props.onPlanChange || !Array.isArray(plans)) return;
        props.onPlanChange(
            plans.find(plan => String(plan.id) === String(props.id)),
        );
    }, [plans, props.id]);

    return (
        <select
            id="planId"
            className="form-select"
            value={props.id}
            onChange={props.onChange}
            required={props.required}
        >
            <option value="">Select...</option>
            {plans && plans.length > 0 ? (
                plans?.map(plan => (
                    <option key={'plan' + plan.id} value={plan.id}>
                        {plan.name}
                    </option>
                ))
            ) : (
                <></>
            )}
        </select>
    );
}

export default SelectPlan;
